import React from "react";
import PreStartQuestionPreview from "./PreStartQuestionPreview";
import viewStyles from "../../JobShiftPreStart/JobShiftPreStartView.module.css";

const getChecklistData = (checklist = {}) => (
  checklist && checklist.data && typeof checklist.data === "object" ? checklist.data : checklist || {}
);

const isQuestionActive = (question) => {
  const value = question && question.active;
  if (typeof value === "string") {
    const normalized = value.trim().toLowerCase();
    return normalized === "1" || normalized === "true";
  }

  return value === 1 || value === true;
};

const getQuestions = (checklist = {}) => {
  const data = getChecklistData(checklist);
  const questions = Array.isArray(data.pre_start_questions) ? data.pre_start_questions : [];

  return questions
    .map((entry) => entry && entry.question ? entry.question : entry)
    .filter(isQuestionActive);
};

export default function PreStartQuestionsPreview({ preStartChecklist }) {
  const checklistData = getChecklistData(preStartChecklist);
  const questions = getQuestions(preStartChecklist);
  const heading = checklistData.prestart_checklist_heading || "";

  return (
    <div className={viewStyles.PreviewSectionBlock}>
      <div className={viewStyles.PreviewSectionHead}>
        <span className={`${viewStyles.PreviewSectionNum} ${viewStyles.PreviewSectionNumPreview}`}>2</span>
        Checklist Questions
      </div>
      <div className={viewStyles.PreviewSectionBody}>
        {heading ? (
          <div className={`${viewStyles.PreviewRichText} preview-swms-v3-authorization-rich-text`} dangerouslySetInnerHTML={{ __html: heading }} />
        ) : null}
        <table className={viewStyles.PreviewTable}>
          <tbody>
            {questions.map((question, index) => (
              <PreStartQuestionPreview
                key={question.id || `prestart-question-${index}`}
                number={index + 1}
                question={question}
              />
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}